import type { ChangeEvent, MouseEvent } from 'react'

interface ChecklistData {
  title?: string
  conditions?: string[]
  items?: string[]
}

interface UsePulseChecklistPanelParams {
  idKey: string
  data?: ChecklistData
  checkedTitles: Record<string, boolean>
  expanded: Record<string, boolean>
  toggleExpanded: (idKey: string) => void
  setCheckedTitle: (idKey: string, checked: boolean) => void
}

const usePulseChecklistPanel = ({
  idKey,
  data,
  checkedTitles,
  expanded,
  toggleExpanded,
  setCheckedTitle,
}: UsePulseChecklistPanelParams) => {
  const conditions = data?.conditions || data?.items || []

  return {
    title: data?.title || '',
    conditions: Array.isArray(conditions) ? conditions : [],
    isChecked: !!checkedTitles[idKey],
    isExpanded: !!expanded[idKey],
    checkboxLabel: `${idKey}-checklist-confirmation`,
    onToggle: () => toggleExpanded(idKey),
    onToggleButtonClick: (event: MouseEvent) => {
      event.stopPropagation()
      toggleExpanded(idKey)
    },
    onCheckboxChange: (event: ChangeEvent<HTMLInputElement>) => setCheckedTitle(idKey, event.target.checked),
    onCheckboxClick: (event: MouseEvent) => event.stopPropagation(),
  }
}

export default usePulseChecklistPanel
